var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupporticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 23.37,
    height: 23.784,
    viewBox: "0 0 23.37 23.784",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_7332",
    x: 0,
    y: 0,
    width: 23.37,
    height: 19.9,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_7334",
    x: 10.809,
    y: 19.088,
    width: 5.939,
    height: 4.696,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Support_icon",
    "data-name": "Support icon",
    transform: "translate(0.893 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7474",
    "data-name": "Group 7474",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7330",
    "data-name": "Path 7330",
    d: "M833.137,108.988l-.464,5.759.189.015a.611.611,0,0,0,.662-.55l.368-4.565a.6.6,0,0,0-.566-.644Z",
    transform: "translate(-812.309 -98.698)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_7473",
    "data-name": "Group 7473"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7331",
    "data-name": "Path 7331",
    d: "M757.247,109.646l.368,4.565a.611.611,0,0,0,.662.55l.189-.015L758,108.988l-.189.014A.6.6,0,0,0,757.247,109.646Z",
    transform: "translate(-757.245 -98.698)",
    fill: "#3c3c3b"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.89, -0.5)",
    filter: "url(#Path_7332)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7332-2",
    "data-name": "Path 7332",
    d: "M779.087,74.394l-.127.774-1.186-.1a.414.414,0,0,0-.461.338l-.619,6.781a.391.391,0,0,0,.394.4l1.872.126a.414.414,0,0,0,.461-.339l.047-.511.526-5.759.047-.511a.311.311,0,0,0,0-.048h0l.118-1.3h-.008a7.62,7.62,0,0,0-.125-1.418,6.785,6.785,0,0,0-1.37-3.115,10.837,10.837,0,0,0-8.535-3.9h-.295a10.838,10.838,0,0,0-8.535,3.9,6.785,6.785,0,0,0-1.369,3.115,7.578,7.578,0,0,0-.125,1.418h-.009l.118,1.3h0a.311.311,0,0,0,0,.048l.046.511.526,5.759h0l.046.511a.414.414,0,0,0,.461.339l1.872-.126a.391.391,0,0,0,.394-.4l-.619-6.781a.414.414,0,0,0-.461-.338l-1.281.1-.094-.774v-.177c0-.1,0-.2,0-.319a6.716,6.716,0,0,1,2.281-4.655q.194-.182.4-.355a9.375,9.375,0,0,1,6.34-1.96h.293a10.183,10.183,0,0,1,6.563,2.249q.208.173.4.355a5.844,5.844,0,0,1,2,4.394c0,.115,0,.223,0,.319Z",
    transform: "translate(-758.29 -65.31)",
    fill: "#3c3c3b"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7476",
    "data-name": "Group 7476",
    transform: "translate(11.416 16.537)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7475",
    "data-name": "Group 7475",
    transform: "translate(2.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7333",
    "data-name": "Path 7333",
    d: "M807.779,138.875q-.4,0-.834-.012l.011-.408c2.8.076,4.435-.222,5.15-.94.532-.535.551-1.257.518-2.3l.408-.013a3.277,3.277,0,0,1-.636,2.6C811.664,138.537,810.225,138.875,807.779,138.875Z",
    transform: "translate(-806.945 -135.204)",
    fill: "#3c3c3b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -12.31, -17.04)",
    filter: "url(#Path_7334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7334-2",
    "data-name": "Path 7334",
    d: "M796.011,145.913a.8.8,0,0,0-.881.707.791.791,0,0,0,.726.857l1.324.124a.8.8,0,0,0,.881-.707.792.792,0,0,0-.726-.857Z",
    transform: "translate(-782.82 -126.32)",
    fill: "#3c3c3b"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupporticon);
export default __webpack_public_path__ + "static/media/Support icon.89628553c516ac335e35d1ac5a98ebc2.svg";
export { ForwardRef as ReactComponent };